module.exports = __webpack_public_path__ + "static/media/icon_order_parents.4f3284bb.svg";